import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {DefaultDeviceCatalogFilters} from "../model/filters/default-device-catalog-filters";
import {DefaultDevicesCatalogResponse} from "../model/responses/default-devices-catalog-response";
import {DefaultDeviceCatalog} from "../model/default-device-catalog";
import {DefaultDeviceCatalogPersistRequest} from "../model/requests/default-device-catalog-persist-request";
import {Trigger} from "../model/trigger";

@Injectable({
  providedIn: 'root'
})
export class HwCatalogService {

  private readonly hwCatalogURL: string;

  constructor(private http: HttpClient) {
    this.hwCatalogURL = '/catalog/hw_catalog';
  }

  public getDefaultDevicesCatalog(offset?: number, limit?: number, filters?: DefaultDeviceCatalogFilters): Observable<DefaultDevicesCatalogResponse> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new DefaultDeviceCatalogFilters();
    return this.http.post<DefaultDevicesCatalogResponse>(this.hwCatalogURL, body, options);
  }

  public getActiveDefaultDevicesCatalog(): Observable<DefaultDevicesCatalogResponse> {
    const url = `${this.hwCatalogURL}/active`;
    return this.http.get<DefaultDevicesCatalogResponse>(url);
  }

  public getDefaultDeviceCatalog(uuid: string): Observable<{ defaultDeviceCatalog: DefaultDeviceCatalog }> {
    const url = `${this.hwCatalogURL}/${uuid}`;
    return this.http.get<{ defaultDeviceCatalog: DefaultDeviceCatalog }>(url);
  }

  public createDefaultDeviceCatalog(defaultDeviceCatalogCreationData: DefaultDeviceCatalogPersistRequest): Observable<any> {
    const url = `${this.hwCatalogURL}/create`;
    return this.http.post<any>(url, defaultDeviceCatalogCreationData);
  }

  public editDefaultDeviceCatalog(defaultDeviceCatalogEditionData: DefaultDeviceCatalogPersistRequest): Observable<any> {
    const url = `${this.hwCatalogURL}/edit`;
    return this.http.post<any>(url, defaultDeviceCatalogEditionData);
  }

  public deleteDefaultDeviceCatalog(uuid: string) {
    let url = `${this.hwCatalogURL}/${uuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteDefaultDevicesCatalog(uuids: string[]): Observable<HttpResponse<any>> {
    const url = `${this.hwCatalogURL}/delete`;
    return this.http.post<any>(url, uuids, {observe: 'response'});
  }

  public updateDefaultDevicesState(uuids: string[], newActiveState: boolean) {
    let options = HttpUtils.buildOptions({newActiveState: newActiveState});
    let url = `${this.hwCatalogURL}/update_state`;
    return this.http.post<any>(url, uuids, options);
  }
}
